import { IHttpService } from "../HttpService";
import FormType, { IFormType } from "../../model/formconfiguration/FormType";
import FormTypeEvaluationType, {
  IFormTypeEvaluationType
} from "../../model/formconfiguration/FormTypeEvaluationType";

export interface IFormTypeService {
  getFormTypes(status?: string): Promise<any>;
  createFormType(formType: IFormType): Promise<any>;
  updateFormType(formType: IFormType): Promise<any>;
  getFormType(formTypeCode: string): Promise<any>;
  copyFormType(formTypeCode: string, newFormType: IFormType): Promise<any>;
  joinEvaluationTypeToFormType(
    formTypeCode: string,
    reviewTypeId: number
  ): Promise<any>;
  removeEvaluationTypeFromFormType(formTypeReviewId: number): Promise<any>;
  getFormTypeEvaluations(
    formTypeCode: string
  ): Promise<IFormTypeEvaluationType[]>;
  createNewFormVersion(
    formTypeCode: string,
    formType: IFormType
  ): Promise<string>;
  publishFormVersion(formTypeCode: string): Promise<string>;
  cancelFormVersion(formTypeCode: string): Promise<string>;
}

const FormTypeService = (httpService): IFormTypeService => {
  const _http: IHttpService = httpService;
  const _baseUrl: string = "/api/codebooks";
  const _formTypesPath = "form-types";
  const _formReviewsPath = "form-evaluations";
  const _formPath = "form";
  const _evaluationType = "evaluation-type";
  const _versionPath = "version";
  const _publishPath = "publish";
  const _cancelPath = "cancel";

  let FormTypeListMapper = (json = []) => {
    return json.map((item: any) => {
      let formType = FormType(item);
      return formType;
    });
  };

  let ParamsMapper = (formType: IFormType) => {
    return {
      code: formType.code,
      name: formType.name,
      tag: formType.tag
    };
  };

  let FormTypeEvaluationMapper = (json = []) => {
    return json.map((item: any) => {
      let formTypeEvaluation = FormTypeEvaluationType(item);
      return formTypeEvaluation;
    });
  };

  return {
    async getFormTypes(status?: string) {
      const path = _http.buildPath(_baseUrl, _formTypesPath);
      const response = await _http.get(path, {
        params: { status: status || null }
      });
      const responseJSON = await _http.toJSON(response);
      return FormTypeListMapper(responseJSON);
    },

    async createFormType(formType: IFormType) {
      const path = _http.buildPath(_baseUrl, _formTypesPath);
      const response = await _http.post(path, {
        params: ParamsMapper(formType)
      });
      return _http.toText(response);
    },

    async updateFormType(formType: IFormType) {
      const path = _http.buildPath(_baseUrl, _formTypesPath, formType.code);
      const response = await _http.put(path, {
        params: ParamsMapper(formType)
      });
      return _http.toText(response);
    },

    async copyFormType(formTypeCode: string, newFormType: IFormType) {
      const path = _http.buildPath(
        _baseUrl,
        _formTypesPath,
        formTypeCode,
        "copy"
      );
      const response = await _http.post(path, {
        params: ParamsMapper(newFormType)
      });
      return _http.toText(response);
    },

    async getFormType(formTypeCode: string) {
      const path = _http.buildPath(_baseUrl, _formTypesPath, formTypeCode);
      const response = await _http.get(path);
      const responseJSON = await _http.toJSON(response);
      return FormType(responseJSON);
    },

    async getFormTypeEvaluations(formTypeCode: string) {
      const path = _http.buildPath(
        _baseUrl,
        _formReviewsPath,
        _formPath,
        formTypeCode
      );
      const response = await _http.get(path);
      const responseJSON = await _http.toJSON(response);
      return FormTypeEvaluationMapper(responseJSON);
    },

    async joinEvaluationTypeToFormType(
      formTypeCode: string,
      reviewTypeId: number
    ) {
      const path = _http.buildPath(
        _baseUrl,
        _formReviewsPath,
        _formPath,
        formTypeCode,
        _evaluationType,
        reviewTypeId.toString()
      );
      const response = await _http.post(path);
      return _http.toText(response);
    },

    async removeEvaluationTypeFromFormType(formTypeReviewId: number) {
      const path = _http.buildPath(
        _baseUrl,
        _formReviewsPath,
        formTypeReviewId.toString()
      );
      const response = await _http.remove(path);
      return _http.toText(response);
    },

    async createNewFormVersion(formTypeCode: string, formType: IFormType) {
      const path = _http.buildPath(
        _baseUrl,
        _formTypesPath,
        formTypeCode,
        _versionPath
      );
      const response = await _http.post(path, {
        params: ParamsMapper(formType)
      });
      return _http.toText(response);
    },

    async publishFormVersion(formTypeCode: string) {
      const path = _http.buildPath(
        _baseUrl,
        _formTypesPath,
        formTypeCode,
        _publishPath
      );
      const response = await _http.put(path);
      return _http.toText(response);
    },

    async cancelFormVersion(formTypeCode: string) {
      const path = _http.buildPath(
        _baseUrl,
        _formTypesPath,
        formTypeCode,
        _cancelPath
      );
      const response = await _http.put(path);
      return _http.toText(response);
    }
  };
};

export default FormTypeService;
